import { RematchDispatch } from '@rematch/core';
import { axiosErrorHandler } from 'common/helpers';
import { IRootModel } from 'app/store';
import { INoteCreatePayload, INoteListParams } from 'entities/Notes/Note.models';
import { noteService } from 'entities/Notes/Note.service';

export const noteListEffects = (dispatch: RematchDispatch<IRootModel>) => ({
  async getNotes(params: INoteListParams) {
    dispatch.noteList.setLoading(true);

    try {
      const response = await noteService.getNotes(params);
      dispatch.noteList.setList(response.data);
    } catch (error) {
      axiosErrorHandler(error);
    } finally {
      dispatch.noteList.setLoading(false);
    }
  },
});

export const noteEffects = (dispatch: RematchDispatch<IRootModel>) => ({
  async createNote(payload: INoteCreatePayload) {
    dispatch.note.setLoading(true);

    try {
      const response = await noteService.createNote(payload);
      dispatch.note.setNote(response);
      dispatch.global.onSuccess(payload);
      dispatch.noteList.getNotes({ eventId: payload.eventId.toString() });
    } catch (error) {
      axiosErrorHandler(error);
    } finally {
      dispatch.note.setLoading(false);
    }
  },
});
